/* eslint-disable max-len */

import { useTranslation } from 'react-i18next';
import { CustomError, ManageCodeLabelColumn } from '../../../../components';
import { holeSize } from '../../../../entityModel';
import {
  TXT_DATA_NOT_FOUND,
  TXT_DELETE,
  TXT_EDIT,
  TXT_LOADING
} from '../../../../translations/translationConstants';
import { capitalizeFirstLetter } from '../../../../shared/stringFunctions';
import { getHoleSizeOutput } from '../../../../api';
import { ApolloError } from '@apollo/client';

export interface ManageHoleSizesTableBodyProps {
  error?: ApolloError;
  loading: boolean;
  data?: getHoleSizeOutput;
  columns: ManageCodeLabelColumn[];
  onEdit: (holeSize: holeSize) => void;
  onDelete: (holeSize: holeSize) => void;
}

export const ManageHoleSizesTableBody =
  ({ error, columns, loading, data, onEdit, onDelete }: ManageHoleSizesTableBodyProps) => {
    const { t } = useTranslation();
    return (
      <tbody>
        {
          loading &&
          <tr>
            <td colSpan={columns.length} style={{ textAlign: 'center' }}>
              <h3>
                {t(TXT_LOADING).toUpperCase()}
              </h3>
            </td>
          </tr>
        }
        {
          !loading && error && error.message &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {error.message}
              </CustomError>
            </td>
          </tr>
        }
        {
          !loading && data &&
          data.holeSizes && data.holeSizes.items &&
          data.holeSizes.items.length > 0 &&
          data.holeSizes.items.map((holeSize) => (
            <tr key={`row-${holeSize.id}`}>
              <td>
                {holeSize.code}
              </td>
              <td>
                {holeSize.label}
              </td>
              <td align='center'>
                <button
                  data-target="#modal-holeSize-editor"
                  data-toggle="modal"
                  className='btn btn-primary'
                  aria-label="edit holeSize"
                  onClick={() => onEdit(holeSize)}>
                  {t(TXT_EDIT).toUpperCase()}
                </button>
              </td>
              <td align='center'>
                <button
                  data-target="#modal-default"
                  data-toggle="modal"
                  className='btn btn-danger'
                  aria-label="delete holeSize"
                  type="button"
                  onClick={() => onDelete(holeSize)}>
                  {t(TXT_DELETE).toUpperCase()}
                </button>
              </td>
            </tr>
          ))
        }
        {
          !loading &&
          (!data ||
            !data.holeSizes ||
            !data.holeSizes.items ||
            data.holeSizes.items.length <= 0) &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {capitalizeFirstLetter(t(TXT_DATA_NOT_FOUND))}
              </CustomError>
            </td>
          </tr>
        }
      </tbody>
    );
  };
